import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ServiceEcosystem = ({ activeView, onViewChange }) => {
  const views = [
    { id: 'ecosystem', label: 'Ecosystem View', icon: 'Network' },
    { id: 'timeline', label: 'Timeline View', icon: 'Clock' },
    { id: 'process', label: 'Process View', icon: 'GitBranch' }
  ];

  const services = [
    {
      id: 'custom-dev',
      title: 'Custom Development',
      icon: 'Code',
      bgColor: 'bg-secondary',
      description: 'Tailored software solutions'
    },
    {
      id: 'digital-transform',
      title: 'Digital Transformation',
      icon: 'Zap',
      bgColor: 'bg-conversion-accent',
      description: 'Strategic technology consulting'
    },
    {
      id: 'mvp-dev',
      title: 'MVP Development',
      icon: 'Rocket',
      bgColor: 'bg-success',
      description: 'Rapid prototyping & validation'
    },
    {
      id: 'enterprise-integration',
      title: 'Enterprise Integration',
      icon: 'Network',
      bgColor: 'bg-primary',
      description: 'Seamless system connectivity'
    }
  ];

  return (
    <div className="space-y-8">
      {/* View Toggle */}
      <div className="flex justify-center">
        <div className="flex bg-muted rounded-brand p-1">
          {views.map((view) => (
            <button
              key={view.id}
              onClick={() => onViewChange(view.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-md transition-all duration-200 ${
                activeView === view.id
                  ? 'bg-background text-secondary shadow-sm'
                  : 'text-text-secondary hover:text-text-primary'
              }`}
            >
              <Icon name={view.icon} size={16} />
              <span className="text-sm font-medium">{view.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Service Ecosystem Display */}
      <div className="relative bg-gradient-to-br from-muted to-background rounded-brand p-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group cursor-pointer transition-all duration-300 hover:scale-105"
            >
              <div className="p-6 bg-background rounded-brand border border-border hover:border-secondary transition-all duration-300 hover-lift">
                {/* Icon */}
                <div className={`w-16 h-16 rounded-brand flex items-center justify-center mb-4 transition-all duration-300 ${service.bgColor} group-hover:scale-110`}>
                  <Icon name={service.icon} size={28} color="white" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-text-primary mb-2 group-hover:text-secondary transition-brand">
                  {service.title}
                </h3>
                <p className="text-sm text-text-secondary">
                  {service.description}
                </p>

                {/* Connection Lines */}
                {index < services.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 left-full w-6 h-0.5 bg-border group-hover:bg-secondary transition-colors duration-300" />
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Connection Lines for Mobile */}
        <div className="lg:hidden mt-6">
          <div className="flex justify-center space-x-4">
            {services.slice(0, -1).map((_, index) => (
              <div key={index} className="w-8 h-0.5 bg-border" />
            ))}
          </div>
        </div>
      </div>

      {/* View Description */}
      <div className="text-center">
        <p className="text-text-secondary">
          {activeView === 'ecosystem' && 'Explore how our services work together to deliver comprehensive solutions'}
          {activeView === 'timeline' && 'See the typical timeline for each service delivery phase'}
          {activeView === 'process' && 'Understand our proven methodology and process flow'}
        </p>
      </div>
    </div>
  );
};

export default ServiceEcosystem;